import axios from 'axios'
import Vue from 'vue'
let axiosRCI = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    headers: {
        'Content-Type': 'application/json',
      },
  })
export async function fetchDatosREGIO (context){
    try{
    context.commit('flushDatosRegio')
    let url = "regio-web/datosregio/getdatosregio"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    let values = new FormData()
    values.append('limit','10')
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')  
    let response = await axiosRCI({
        method: 'POST',
        url: url,
        data: values
    })
         
    context.commit('setDatosRegio',response.data.data)
  
    }catch(error){
        context.commit('datosregioError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}
export async function fetchDatosREGIObyVendor (context,payload){
    try{
        context.commit('flushDatosRegio')
        let url = "regio-web/datosregio/getbyvendor"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',payload)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosRCI({
            method: 'POST',
            url: url,
            data: values
        })    
        context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
/**
 * Metodo que agrega Estatus Nai a la tabla
 * @param {*} context 
 */
export async function fetchDatosREGIObyIngenieria (context){
    try{
        context.commit('flushDatosRegio')
        let url = "regio-web/datosregio/getbyingenieria"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('limit','10')
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosRCI({
            method: 'POST',
            url: url,
            data: values
        })    
        context.commit('setDatosRci',response.data.data)
    }catch(error){
        context.commit('datosrciError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}